import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';

export const MISSED_CALL_CHANNEL_ID = 'missed-calls';
export const MISSED_CALL_TITLE = 'Missed Call';

const isAndroidNative = () =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';

export const getMissedCallNotificationId = (callId) => {
  if (!callId) return 0;
  let hash = 0;
  for (let i = 0; i < callId.length; i += 1) {
    hash = (hash * 31 + callId.charCodeAt(i)) | 0;
  }
  const abs = Math.abs(hash);
  return abs === 0 ? 1 : abs;
};

export const postMissedCallNotification = async ({ callId, callerLabel }) => {
  if (!isAndroidNative() || !callId) return;

  const permissions = await LocalNotifications.checkPermissions();
  if (permissions.display !== 'granted') {
    const granted = await LocalNotifications.requestPermissions();
    if (granted.display !== 'granted') return;
  }

  const id = getMissedCallNotificationId(callId);
  try {
    const delivered = await LocalNotifications.getDeliveredNotifications();
    if (delivered?.notifications?.some((n) => n.id === id)) {
      return;
    }
  } catch (err) {
    console.warn('Failed to read delivered notifications:', err);
  }

  const body = callerLabel ? `Missed call from ${callerLabel}` : 'Missed call';

  await LocalNotifications.schedule({
    notifications: [
      {
        id,
        title: MISSED_CALL_TITLE,
        body,
        channelId: MISSED_CALL_CHANNEL_ID,
        extra: { type: 'missed_call', callId },
      },
    ],
  });
};

export const clearMissedCallNotification = async (callId) => {
  if (!isAndroidNative() || !callId) return;
  const id = getMissedCallNotificationId(callId);
  try {
    await LocalNotifications.removeDeliveredNotifications({
      notifications: [{ id }],
    });
  } catch (err) {
    console.warn('Failed to remove delivered missed call notification:', err);
  }
  try {
    await LocalNotifications.cancel({ notifications: [{ id }] });
  } catch (err) {
    console.warn('Failed to cancel missed call notification:', err);
  }
};

export const clearAllMissedCallNotifications = async () => {
  if (!isAndroidNative()) return;
  try {
    const delivered = await LocalNotifications.getDeliveredNotifications();
    const missed = (delivered?.notifications || []).filter(
      (n) => n.title === MISSED_CALL_TITLE
    );
    if (!missed.length) return;
    await LocalNotifications.removeDeliveredNotifications({
      notifications: missed.map((n) => ({ id: n.id })),
    });
  } catch (err) {
    console.warn('Failed to clear missed call notifications:', err);
  }
};
